const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Workshops Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('MultiSessionWorkshops', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/multi-session-workshops/:subresource/:subsubresource/:sessionid', null, {
    findOne: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    findParent: {params: {subresource: 'findParent'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    createSession: {params: {subresource: '', subsubresource: 'session'}, method: 'POST', isArray: false},
    updateSession: {params: {subresource: '', subsubresource: 'session', sessionid: ''}, method: 'POST', isArray: false},
    register: {params: {subresource: '', subsubresource: 'register'}, method: 'POST', isArray: false},
    unregister: {params: {subresource: '', subsubresource: 'unregister'}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: '', subsubresource: 'duplicate'}, method: 'POST', isArray: false},
    deleteSession: {params: {subresource: '', subsubresource: 'session', sessionid: ''}, method: 'DELETE', isArray: false},
  });
}]);
